import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Api } from "../../services/api";

const VpSalesAndMarketingDashboard = () => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [globalFilter, setGlobalFilter] = useState('');
    const [projects, setProjects] = useState([]);
    const [searchprojects, setSearchprojectsProjects] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const [projectsArchive, setProjectsArchive] = useState([]);
    const [searchprojectsArchive, setSearchprojectsArchive] = useState([]);

    const [searchprojectsWarranty, setSearchprojectsWarranty] = useState([]);

    const [archiveId, setArchiveId] = useState('');








    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            first_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            last_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            ProjectType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },



        });
        setGlobalFilterValue('');
    };

    /** search Filtter function End */

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between m-2">
            <div></div>
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    value={globalFilterValue} onChange={onGlobalFilterChange}
                    // onChange={(e) => searchproject(e.target.value)}
                    placeholder="Search..."
                />
            </span>
        </div>
    );


    useEffect(() => {
        getProjectDetails();
        initFilters();
        return () => {

        };
    }, []);

    const getProjectDetails = () => {

        fetch(Api.API_BASE_URL + 'vp-sales-marketing/get-all', {
            method: "GET",
        })
            .then((response) => response.json())
            .then((response) => {

                setProjects(response.result);
                setIsLoading(false);


            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);

            });
    }

    const archiveComplateion = () => {
        // fetch.
        var _body = {
            userId: 1,
        }
        fetch(Api.API_BASE_URL + 'pm-template/archive-template/' + archiveId, {
            method: "POST",

            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                // setIsLoading(false);

                getProjectDetails();
            })
            .catch((error) => {
                // setIsLoading(false);
                toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'success', life: 3000 });
                console.error("Error:", error);
            });
    }



    const accept = () => {
        archiveComplateion();
    }

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }

    const handleArchiveProject = (id) => {
        console.log("Archive id", id)
        setArchiveId(id);
        (confirmDialog({
            className: 'flex m-4',
            message: (
                <div className="flex flex-column m-4">

                    <span>Do you want to delete this record?</span>
                </div>
            ),
            header: (
                <div className="flex flex-column m-2">

                    <span>Delete Confirmation</span>
                </div>
            ),

            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger m-2 p-2',
            rejectClassName: 'm-2  p-2',
            accept,
            reject
        }))

        // archiveComplateion();
    };

    const edit = (rowData) => {
        console.log(rowData);
        navigate('/vp-sales-and-marketing/view/' + rowData.user_id + '/' + rowData.role_id);

    }



    const onSelectionChange = (e) => {
        console.log("Selected Product", e.value)
        setSelectedProduct(e.value)
        edit(e.value.id, e.value.projectId);
    }

    return (
        <>


            <Toast ref={toast} />
            <ConfirmDialog />


            <div className="one-line-container">
            </div>

            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (

                <div className="pagee-container">
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                        <TabPanel header="" className="p-2 pb-2" >
                            <div className=" m-0" style={{ width: "100%" }} >
                                {/* onSelectionChange={(e) => onSelectionChange(e)}  */}
                                <DataTable value={projects} paginator rows={10} dataKey="id" selection={selectedProduct}
                                    onSelectionChange={(e) => edit(e.value)}
                                    selectionMode="single" header={header} filters={filters} globalFilterFields={['project_name', 'ProjectType', 'first_name', 'last_name']}  >

                                    <Column header="Name" body={(e) => <span>{e.first_name + ' ' + e.last_name}</span>} className="h-3rem" ></Column>
                                    <Column field="from_date" header="Date" className="h-3rem" ></Column>
                                    <Column field="year" header="Year" ></Column>
                                    <Column field="year_goal" header="Year Goal" ></Column>

                                </DataTable>
                            </div>
                        </TabPanel>
                    </TabView>
                </div>

            )}
        </>
    )
}

export default VpSalesAndMarketingDashboard;